// import { configureStore } from "@reduxjs/toolkit";
// import reportReducer from "../features/report/reportSlice";
// import thingReducer from "../features/thing/thingSlice";
// import vehicleReducer from "../features/vehicle/vehicleSlice";
// import geoFenceReducer from "../features/geoFence/geoFenceSlice";
// import apiDataReducer from "../features/account/accountSlice"; // existing
// import apiGetDataReducer from "../features/accountGet/accountSlice"; // ✅ newly added slice
// // import journeyReducer from "../features/journey/journeySlice";
// import journeyReducer from "../features/journey/journeySlice";
// import routeReplayReducer from "../features/routeReplay/routeReplaySlice";
// import documentReducer from "../features/documents/documentSlice";
// import alertReducer from "../features/alert/alertSlice";
// import groupsReducer from "../features/management/vehicleGroup/groupsSlice";
// import userReducer from "../features/management/userManagement/userSlice";
// import studentReducer from "../features/StudentData/studentSlice";
// import planningReducer from "../features/planning/planningSlice";
// import orgReducer from "../features/OrgAdmin/orgAdminSlice";
// import accountReducer from "../features/accounts/accountSlice";
// import deviceConfigReducer from "../features/deviceConfig/deviceConfigSlice";
// import catchmentDataReducer from "../features/catchmentJourney/catchmentSlice";
// import fleetReducer from '../features/live_map/fleetSlice';

// const store = configureStore({
//   reducer: {
//     report: reportReducer,
//     things: thingReducer,
//     vehicle: vehicleReducer,
//     geoFence: geoFenceReducer,
//     routeReplay: routeReplayReducer,
//     document: documentReducer,
//     alerts: alertReducer,
//     groups: groupsReducer,
//     user: userReducer,
//     apiData: apiDataReducer,
//     apiGetData: apiGetDataReducer,
//     journey: journeyReducer,
//     student: studentReducer,
//     planning: planningReducer,
//     org: orgReducer,
//     account: accountReducer,
//     deviceConfig: deviceConfigReducer,
//     catchmentData: catchmentDataReducer,
//     fleet: fleetReducer,
//   },
// });

// export default store;


import { configureStore, combineReducers } from "@reduxjs/toolkit";
import reportReducer from "../features/report/reportSlice";
import thingReducer from "../features/thing/thingSlice";
import vehicleReducer from "../features/vehicle/vehicleSlice";
import geoFenceReducer from "../features/geoFence/geoFenceSlice";
import apiDataReducer from "../features/account/accountSlice"; 
import apiGetDataReducer from "../features/accountGet/accountSlice"; 
import journeyReducer from "../features/journey/journeySlice";
import routeReplayReducer from "../features/routeReplay/routeReplaySlice";
import documentReducer from "../features/documents/documentSlice";
import alertReducer from "../features/alert/alertSlice";
import groupsReducer from "../features/management/vehicleGroup/groupsSlice";
import userReducer from "../features/management/userManagement/userSlice";
import studentReducer from "../features/StudentData/studentSlice";
import planningReducer from "../features/planning/planningSlice";
import orgReducer from "../features/OrgAdmin/orgAdminSlice";
import accountReducer from "../features/accounts/accountSlice";
import deviceConfigReducer from "../features/deviceConfig/deviceConfigSlice";
import catchmentDataReducer from "../features/catchmentJourney/catchmentSlice";
import fleetReducer from '../features/live_map/fleetSlice';

// 1. combineReducers me saare slices daalein
const appReducer = combineReducers({
  report: reportReducer,
  things: thingReducer,
  vehicle: vehicleReducer,
  geoFence: geoFenceReducer,
  routeReplay: routeReplayReducer,
  document: documentReducer,
  alerts: alertReducer,
  groups: groupsReducer,
  user: userReducer,
  apiData: apiDataReducer,
  apiGetData: apiGetDataReducer,
  journey: journeyReducer,
  student: studentReducer,
  planning: planningReducer,
  org: orgReducer,
  account: accountReducer,
  deviceConfig: deviceConfigReducer,
  catchmentData: catchmentDataReducer,
  fleet: fleetReducer,
});

// 2. Root reducer banayein jo LOGOUT aane par state ko wipe karega
const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    // State ko undefined pass karne se saare slices apne initial/empty state me chale jayenge
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

// 3. Store configure karein
const store = configureStore({
  reducer: rootReducer,
});

export default store;